var React = require('react');

function ArrowSwirlUp24x40 (props) {
    return React.createElement("svg",props,[React.createElement("g",{"id":"Size=24x40, Invert=off, Flip=off","clipPath":"url(#clip0_6934_26244)","stroke":"currentColor","strokeWidth":"2","strokeMiterlimit":"10","key":0},[React.createElement("path",{"id":"Vector","d":"M20.991 4.215l-6.487-3.118-1.018.353-2.7 6.294","strokeLinecap":"round","key":0}),React.createElement("path",{"id":"Vector_2","d":"M13.895 1.373s8.809 18.088.332 23.044c-7.105 4.151-11.973-1.075-10.414-4.95 1.658-4.136 7.459-4.56 10.32.142 3.372 5.607 1.991 19.63 1.991 19.63","key":1})]),React.createElement("defs",{"key":1},React.createElement("clipPath",{"id":"clip0_6934_26244"},React.createElement("path",{"fill":"#fff","d":"M0 0h24v40H0z"})))]);
}

ArrowSwirlUp24x40.defaultProps = {"width":"24","height":"40","viewBox":"0 0 24 40","fill":"none"};

module.exports = ArrowSwirlUp24x40;

ArrowSwirlUp24x40.default = ArrowSwirlUp24x40;
